import { BaseProxy, type ProxyMethods } from '@/proxies/Proxy'

export default class CompanyPriceProxy extends BaseProxy implements ProxyMethods {
  public endpoint = 'prices/company'

  getDefaultPrices(id: string) {
    return this.submit('get', `/${this.endpoint}/${id}/default`)
  }

  getDiffPrices(id: string) {
    return this.submit('get', `/${this.endpoint}/${id}/difference`)
  }
}
